import { AuthorizationScope } from '../AuthorizationScope'

const scope: AuthorizationScope = {
  _id: 'WORKSPACE_PROJECT_LAND_USE_AND_CARBON_RIGHTS',
  name: 'Workspace Project Land Use and Carbon Rights',
  type: 'PROJECT',
  description: '',
  modules: [],
  actions: ['READ', 'CREATE', 'DESTROY'],
}

export default scope
